const Utils = {
  ConvertStringToHTML(str) {
    let parser = new DOMParser()
    let doc = parser.parseFromString(str, 'text/html')
    return doc.body
  },
  ConvertStringToJS(str) {
    var script = document.createElement("script")
    script.text = str
    document.head.appendChild(script).parentNode.removeChild(script)
  },
  async PromisesSequential(PromiseArr) {
    let res = [];
    for (let i=0; i < PromiseArr.length; i++) {
      res.push(await PromiseArr[i])
    }
    return res
  }  
};

document.addEventListener('alpine:init', () => {
  Alpine.data('CollectionVariants', () => ({
    collection: {
      products_to_display: []
    },
    page: 1,
    flags: {
      loading: true,
      isLastPage: false
    },
    mounted() {
      let am = this;

      am.LoadAllPages();
    },
    LoadMore() {
      am = this;

      am.page += 1
      am.flags.isLastPage = (am.page >= am.collection.paginate.page_size);

      (async () => {
        let section_id = am.$el.dataset.section_id
        let url  = `${am.collection.paginate.next.url}&sections=${ section_id }`
        console.log(url)
        let res = await fetch(url).then((res => res.json()))
        console.log(res)
        let $section = Utils.ConvertStringToHTML(res[section_id])
        let script_json = $section.querySelector('#products-json')

        Utils.ConvertStringToJS(script_json.innerText)
        am.collection = window.collection
        am.flags.loading = false
      })()
    },
    LoadAllPages() {
      let am = this;
      let section_id = am.$el.dataset.section_id;
      let view = am.$el.dataset.view;

      (async () => {
        let urls = []
        for (let i = 2; i <= window.collection.paginate.pages; i++) {
          urls.push(`${ window.location.href }?&page=${ i }&sections=${ section_id }&view=${ view }`)
        }
        let px_urls = urls.map(async(url) => {
          return await fetch(url).then(res => res.json())
        })

        let px_res = await Utils.PromisesSequential(px_urls)
        px_res.forEach((res) => {
          let $section = Utils.ConvertStringToHTML(res[section_id]);
          let script_json = $section.querySelector('#products-json');
  
          Utils.ConvertStringToJS(script_json.innerText);

          // filter out products without variants to display
          collection.products_to_display = collection.products_to_display.filter(product => product.variants_to_display.length > 0)

          am.collection = collection
          am.flags.loading = false
        })
      })()
    }
  }));
});